import React, { useState } from 'react';

function Referal() {
  const [formData, setFormData] = useState({
    supportsCoordinatorName: '',
    supportsCoordinatorAgency: '',
    supportsCoordinatorEmail: '',
    supportsCoordinatorPhone: '',
    parentName: '',
    parentNumber: '',
    clientMemberId: '',
    serviceType: '',
    availability: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Show loading state
      const submitButton = e.target.querySelector('button[type="submit"]');
      const originalText = submitButton.textContent;
      submitButton.textContent = 'Sending...';
      submitButton.disabled = true;

      // Prepare form data for PHP
      const formDataToSend = {
        ...formData,
        formType: 'referral'
      };

      // Send data to PHP email handler
      const response = await fetch('/email_handler.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataToSend)
      });

      const result = await response.json();

      if (result.success) {
        alert('Referral form submitted successfully! We will contact you soon.');
        // Reset form
        setFormData({
          supportsCoordinatorName: '',
          supportsCoordinatorAgency: '',
          supportsCoordinatorEmail: '',
          supportsCoordinatorPhone: '',
          parentName: '',
          parentNumber: '',
          clientMemberId: '',
          serviceType: '',
          availability: ''
        });
      } else {
        alert(`Error submitting form: ${result.message || 'Unknown error occurred'}`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred while submitting the form. Please try again.');
    } finally {
      // Reset button state
      const submitButton = e.target.querySelector('button[type="submit"]');
      submitButton.textContent = 'Submit Referral';
      submitButton.disabled = false;
    }
  };

  return (
    <div className="slds-grid slds-gutters">
      <div className="slds-col slds-size_1-of-1">
        <div className="slds-card">
          <div className="slds-card__body slds-card__body_inner">
            <h1 className="slds-text-heading_large slds-p-bottom_medium">Referral Form</h1>
            
            <form onSubmit={handleSubmit} className="slds-form">
              {/* Supports Coordinator Information */}
              <h2 className="slds-text-heading_medium slds-p-bottom_small">Supports Coordinator Information</h2>
              
              <div className="slds-form-element">
                <label className="slds-form-element__label" htmlFor="supportsCoordinatorName">
                  <abbr className="slds-required" title="required">*</abbr>
                  Supports Coordinator Name
                </label>
                <div className="slds-form-element__control">
                  <input
                    type="text"
                    id="supportsCoordinatorName"
                    name="supportsCoordinatorName"
                    className="slds-input"
                    value={formData.supportsCoordinatorName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="slds-form-element">
                <label className="slds-form-element__label" htmlFor="supportsCoordinatorAgency">
                  <abbr className="slds-required" title="required">*</abbr>
                  Supports Coordinator Agency
                </label>
                <div className="slds-form-element__control">
                  <input
                    type="text"
                    id="supportsCoordinatorAgency"
                    name="supportsCoordinatorAgency"
                    className="slds-input"
                    value={formData.supportsCoordinatorAgency}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="slds-form-element">
                <label className="slds-form-element__label" htmlFor="supportsCoordinatorEmail">
                  <abbr className="slds-required" title="required">*</abbr>
                  Supports Coordinator Email
                </label>
                <div className="slds-form-element__control">
                  <input
                    type="email"
                    id="supportsCoordinatorEmail"
                    name="supportsCoordinatorEmail"
                    className="slds-input"
                    value={formData.supportsCoordinatorEmail}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="slds-form-element">
                <label className="slds-form-element__label" htmlFor="supportsCoordinatorPhone">
                  <abbr className="slds-required" title="required">*</abbr>
                  Supports Coordinator Phone
                </label>
                <div className="slds-form-element__control">
                  <input
                    type="tel"
                    id="supportsCoordinatorPhone"
                    name="supportsCoordinatorPhone"
                    className="slds-input"
                    value={formData.supportsCoordinatorPhone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              {/* Parent Information */}
              <h2 className="slds-text-heading_medium slds-p-bottom_small slds-p-top_medium">Parent Information</h2>

              <div className="slds-form-element">
                <label className="slds-form-element__label" htmlFor="parentName">
                  <abbr className="slds-required" title="required">*</abbr>
                  Parent Name
                </label>
                <div className="slds-form-element__control">
                  <input
                    type="text"
                    id="parentName"
                    name="parentName"
                    className="slds-input"
                    value={formData.parentName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="slds-form-element">
                <label className="slds-form-element__label" htmlFor="parentNumber">
                  <abbr className="slds-required" title="required">*</abbr>
                  Parent Phone Number
                </label>
                <div className="slds-form-element__control">
                  <input
                    type="tel"
                    id="parentNumber"
                    name="parentNumber"
                    className="slds-input"
                    value={formData.parentNumber}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              {/* Client Information */}
              <h2 className="slds-text-heading_medium slds-p-bottom_small slds-p-top_medium">Client Information</h2>

              <div className="slds-form-element">
                <label className="slds-form-element__label" htmlFor="clientMemberId">
                  <abbr className="slds-required" title="required">*</abbr>
                  Client Member ID
                </label>
                <div className="slds-form-element__control">
                  <input
                    type="text"
                    id="clientMemberId"
                    name="clientMemberId"
                    className="slds-input"
                    value={formData.clientMemberId}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="slds-form-element">
                <label className="slds-form-element__label" htmlFor="serviceType">
                  <abbr className="slds-required" title="required">*</abbr>
                  Center or Home Based Services
                </label>
                <div className="slds-form-element__control">
                  <select
                    id="serviceType"
                    name="serviceType"
                    className="slds-select"
                    value={formData.serviceType}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Service Type</option>
                    <option value="center">Center Based</option>
                    <option value="home">Home Based</option>
                    <option value="both">Both</option>
                  </select>
                </div>
              </div>

              <div className="slds-form-element">
                <label className="slds-form-element__label" htmlFor="availability">
                  <abbr className="slds-required" title="required">*</abbr>
                  Availability
                </label>
                <div className="slds-form-element__control">
                  <textarea
                    id="availability"
                    name="availability"
                    className="slds-textarea"
                    rows="4"
                    placeholder="Please describe the client's availability for services..."
                    value={formData.availability}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="slds-form-element slds-p-top_medium">
                <div className="slds-form-element__control">
                  <button
                    type="submit"
                    className="slds-button slds-button_brand"
                  >
                    Submit Referral
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Referal; 